import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LoadingSpinner from '../Common/LoadingSpinner';

const Impersonate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const userStr = params.get('user');

    if (token) {
      // Save user token and minimal user data to ensure AuthContext initializes
      localStorage.setItem('token', token);
      
      if (userStr) {
        localStorage.setItem('user', userStr);
      } else {
        localStorage.removeItem('user');
      }
      
      // Full reload to ensure AuthContext re-initializes
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 500);
    } else {
      navigate('/login');
    }
  }, [location, navigate]);

  return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyItems: 'center' }}>
      <LoadingSpinner size="large" message="Establishing administrative session..." />
    </div>
  );
};

export default Impersonate;
